// stores/map/types.ts

import { FeatureCollection } from 'geojson';
import { Coordinate } from 'ol/coordinate';
import { Extent } from 'ol/extent';
import { Feature } from 'ol';
import { basemaps } from '@/components/map/components/controls/BasemapControl';
import { LayerDefinition } from '@packages/database/types';

export type MapInteractionMode =
  | 'view'
  | 'selectAssets'
  | 'selectProjectArea'
  | 'addNote'
  | 'addFieldCorrection'
  | 'redlining';

// ✅ Default generic tools + NONE + layer asset type slugs
export type DefaultRedlineTool =
  | 'NONE'
  | 'POINT'
  | 'LINESTRING'
  | 'POLYGON'
  | 'LABEL'
  | 'FREEHAND';

export type RedlineTool = DefaultRedlineTool | string; // string covers layer slugs

// ✅ Which tools should never open an attribute popup
export const NO_POPUP_TOOLS: ReadonlySet<string> = new Set([
  'POINT',
  'LINESTRING',
  'POLYGON',
  'FREEHAND',
  'LABEL',
]);

// ✅ Which tools have no editable attributes in the summary
export const NO_EDIT_TOOLS: ReadonlySet<string> = new Set([
  'POINT',
  'LINESTRING',
  'POLYGON',
  'FREEHAND',
  'LABEL',
]);

export type MapLayerTypes =
  | 'service-area'
  | 'field-note'
  | 'ticket'
  | 'redline'
  | 'asset'
  | 'premise';

export type BasemapType = keyof typeof basemaps;

export interface SelectionCandidate {
  id: string;
  feature: Feature;
  layer: LayerDefinition;
}

export interface MapMarkerLocation {
  coordinate: Coordinate;
  data?: any;
}

export interface ProjectAreaFeature {
  id: string;
  layerKey: string;
  sourceTable: string;
  properties: Record<string, unknown>;
}

export interface ProjectAreaSelection {
  serviceAreaId: string;
  boundaryExtent: Extent;
  features: ProjectAreaFeature[];
}
